import { render, staticRenderFns } from "./CampusDocs.vue?vue&type=template&id=2a446799&scoped=true&"
import script from "./CampusDocs.vue?vue&type=script&lang=ts&"
export * from "./CampusDocs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a446799",
  null
  
)

export default component.exports